module.exports = __webpack_public_path__ + "static/media/q2.3d0fa515.png";